import partnerProfile from "@/services/partnerProfile"

const state = {}

const getters = {}

const mutations = {}

const actions = {
    uploadPartnerProfile: async ({ dispatch }, { organisation_id, formData }) => {

        dispatch("showToast", {
            class: "bg-info text-white",
            message: "Uploading profile content...",
        })

        try {
            const res = await partnerProfile.uploadPartnerProfile(
                organisation_id,
                formData
            )

            dispatch("clearAllToast")

            dispatch("showToast", {
                class: "bg-success text-white",
                message: "Profile content updated successfully!",
            })

            return res
        } catch (err) {

            dispatch("clearAllToast")

            dispatch("showToast", {
                class: "bg-danger text-white",
                message:
                    err?.response?.data?.detail || "Upload failed. Please try again.",
            })

            return err
        }
    },
    getPartnerDocuments: async ({ commit, dispatch }, { organisation_id, customer_id }) => {
        try {
            const res = await partnerProfile.getPartnerDocuments(
                organisation_id,
                customer_id
            )
            return res.data.documents
        } catch (err) {
            dispatch("showToast", {
                class: "bg-danger text-white",
                message: "Failed to fetch existing documents",
            })
            return []
        }
    },
    getPartnerDocumentFile: async ({ dispatch }, { organisation_id, document_id, preview }) => {
        try {
            const res = await partnerProfile.getPartnerDocumentFile(
                organisation_id,
                document_id,
                preview
            )
            return res.data
        } catch (err) {
            dispatch("showToast", {
                class: "bg-danger text-white",
                message: "Failed to load preview file"
            })
            return null
        }
    }

}

export default {
    state,
    getters,
    mutations,
    actions,
}
